export default "__VITE_ASSET__B1c7vvkq__"